module.exports = __webpack_public_path__ + "img/CREDITOM_200x120.f88adb70.png";